// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folder_item-module__link--2-1Ys{max-width:95%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;text-align:left}@media screen and (max-width: 48em){.folder_item-module__link--2-1Ys{max-width:90%}}.folder_item-module__label--1lln4{max-width:100%;padding:0 5px;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;display:inline-block;vertical-align:middle}\n", ""]);
// Exports
exports.locals = {
	"link": "folder_item-module__link--2-1Ys",
	"label": "folder_item-module__label--1lln4"
};
module.exports = exports;
